import React, { useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Card } from "semantic-ui-react";
import "../styles/ui.scss";
import "../styles/main.scss";
import { createErrorResponse } from "../Helpers";
import { declineMockGuarantorInvitation } from "../api/mock/MockBrokerApi";
import { declineGuarantorInvitation } from "../api/BrokerApi";
import { FeatureFlags } from "./constants/LocalServerConstants";
import { getIsWhiteLabeled } from "../helpers/PermissionHelper";

const BCDecline = () => {
  const history = useHistory();
  const handleHome = useCallback(() => {
    history.push("/");
  }, [history]);

  const handleError = useCallback(() => {
    history.push("/error");
  }, [history]);

  useEffect(() => {
    const declineGuarantorInvitationAsync = async (declineId, declineObj) => {
      try {
        FeatureFlags.IS_MOCK ? await declineMockGuarantorInvitation(declineId, declineObj) : await declineGuarantorInvitation(declineId, declineObj);
      }
      catch (error: any) {
        createErrorResponse("Error", "Caught Error while trying to getApplicationInfoAsync", undefined , "borrowerapplication/info", undefined, error.status, "GET", error);
        handleError();
      }
    };

    const guarantorDeclineAsync = async (borowerApplicationId, declineEmail, declineId) => {
      const declineObj = {
        borrowerApplicationId: borowerApplicationId,
        guarantorEmail: declineEmail
      };

      await declineGuarantorInvitationAsync(declineId, declineObj);
    };

    if (!getIsWhiteLabeled()) {
      handleHome();
    }
    else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const declineBorowerApplicationId = window.location.pathname.replace("/application/guarantor/decline/", "") as string;
      const declineId = params.id;
      const declineEmail = decodeURIComponent(params.email);
      guarantorDeclineAsync(declineBorowerApplicationId, declineEmail, declineId);
    }
  }, [handleHome, handleError]);

  return (
    <div className="decline-container">
      {getIsWhiteLabeled()  && <Card className="decline-card vertical-center">
        <Card.Content className="decline-content">
          <Card.Header className="decline-header">Your response has been received.</Card.Header>
          <Card.Description className="decline-description">Thanks for responding! Have a wonderful day.</Card.Description>
        </Card.Content>
      </Card>}
    </div>
  );
};

export default BCDecline;